/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type EventSmartHoldInfo_smartHoldEventInfo = {
    readonly isPreTravelTime: boolean;
    readonly isPostTravelTime: boolean;
    readonly isMeetingPrep: boolean;
    readonly originEvent: {
        readonly title: string | null;
        readonly eventKey: {
            readonly externalEventId: string;
        };
        readonly annotatedEvent: {
            readonly userTags: ReadonlyArray<{
                readonly tag: string;
                readonly states: ReadonlyArray<{
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly value: string | null;
                }> | null;
            }> | null;
        } | null;
    };
    readonly " $refType": "EventSmartHoldInfo_smartHoldEventInfo";
};
export type EventSmartHoldInfo_smartHoldEventInfo$data = EventSmartHoldInfo_smartHoldEventInfo;
export type EventSmartHoldInfo_smartHoldEventInfo$key = {
    readonly " $data"?: EventSmartHoldInfo_smartHoldEventInfo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSmartHoldInfo_smartHoldEventInfo">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSmartHoldInfo_smartHoldEventInfo",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPreTravelTime",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPostTravelTime",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMeetingPrep",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "originEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventKey",
                    "kind": "LinkedField",
                    "name": "eventKey",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalEventId",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnnotatedEvent",
                    "kind": "LinkedField",
                    "name": "annotatedEvent",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserTag",
                            "kind": "LinkedField",
                            "name": "userTags",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tag",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TagState",
                                    "kind": "LinkedField",
                                    "name": "states",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subjectType",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subjectValue",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "value",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "SmartHoldEventInfo",
    "abstractKey": null
} as any;
(node as any).hash = '6d4fb68fcb4edeeef8200f105566c68b';
export default node;
